import type { CommonNode } from '@vedalib/editor'
import { isCommonNode } from '@vedalib/editor'
import React from 'react'

import { nodeWithDeviceMode } from 'components/Editor/EditorContext/selectors/block'
import type { PreviewMode } from 'services/Store/Project/enums'

import type { INodeComponentProps, IRowProps } from '../Node/types'
import EditorRow from './EditorRow'
import PreviewRow from './PreviewRow'

const BLOCK_COMPONENTS: Partial<Record<PreviewMode, React.FC<IRowProps>>> = {
  editor: EditorRow,
}

const RowContainer: React.FC<INodeComponentProps<CommonNode>> = (props) => {
  const { node, mode } = props
  const { style } = nodeWithDeviceMode(node, mode.deviceMode)
  const Component = BLOCK_COMPONENTS[mode.previewMode] || PreviewRow

  if (isCommonNode(node)) {
    return <Component {...props} node={node} style={style} />
  }
  return null
}

export default React.memo(RowContainer)
